import type { CartFormValues } from '../model/cart-context';

/** Bump with shape changes; keep only the last CART_MIGRATE_WINDOW migration steps in the bundle. */
export const CART_STORAGE_VERSION = 1;

export const CART_MIGRATE_WINDOW = 2;

/** Cleared on successful order via defaults; still persisted while shopping. */
export const CART_ORDER_EPHEMERAL_KEYS = ['tips'] as const satisfies ReadonlyArray<keyof CartFormValues>;

export type CartStorage = Partial<CartFormValues> & { _v?: number };

type CartMigration = (state: CartStorage) => CartStorage;

/** From-version → next. Drop steps older than CURRENT − WINDOW when bumping. */
export const CART_STORAGE_MIGRATIONS: Record<number, CartMigration> = {
    0: (state) => ({ ...state, tips: {} }),
};

type MigrateOptions = {
    current?: number;
    window?: number;
    migrations?: Record<number, CartMigration>;
};

export type MigrateCartStorageResult = { ok: true; values: CartStorage; didChange: boolean } | { ok: false };

/** Upgrade parsed cart to current `_v`, or `{ ok: false }` to wipe storage. */
export function migrateCartStorage(
    parsed: CartStorage,
    {
        current = CART_STORAGE_VERSION,
        window = CART_MIGRATE_WINDOW,
        migrations = CART_STORAGE_MIGRATIONS,
    }: MigrateOptions = {},
): MigrateCartStorageResult {
    const initialVersion = parsed._v ?? 0;
    if (initialVersion > current || initialVersion < current - window) {
        return { ok: false };
    }

    let values: CartStorage = { ...parsed, _v: current };
    for (let from = initialVersion; from < current; from++) {
        const step = migrations[from];
        if (!step) {
            return { ok: false };
        }
        values = step(values);
    }

    return {
        ok: true,
        values,
        didChange: initialVersion !== current || parsed._v !== current,
    };
}
